export const PTD_TYPE_CHILD_SUPPORT = 'child_support';
export const PTD_TYPE_MISC = 'miscellaneous';
export const PTD_TYPE_CALSAVERS = 'calsavers';
export const PTD_TYPE_MISC_GARNISHMENT = 'miscellaneous_garnishment';

export const PTD_TYPES_LABEL = {
  [PTD_TYPE_CHILD_SUPPORT]: 'Child Support Garnishment',
  [PTD_TYPE_MISC]: 'Miscellaneous',
  [PTD_TYPE_CALSAVERS]: 'CalSavers',
  [PTD_TYPE_MISC_GARNISHMENT]: 'Miscellaneous Garnishment',
};

export const PTD_TYPE_OPTIONS = [
  { value: PTD_TYPE_CHILD_SUPPORT, label: PTD_TYPES_LABEL.child_support },
  { value: PTD_TYPE_MISC, label: PTD_TYPES_LABEL.miscellaneous },
];

export const PTD_TYPE_OPTIONS_WITH_CALSAVERS = [
  { value: PTD_TYPE_CHILD_SUPPORT, label: PTD_TYPES_LABEL.child_support },
  { value: PTD_TYPE_MISC, label: PTD_TYPES_LABEL.miscellaneous },
  { value: PTD_TYPE_CALSAVERS, label: PTD_TYPES_LABEL.calsavers },
];

export const PTD_TYPE_OPTIONS_WITH_MISC_GARNISHMENT = [
  { value: PTD_TYPE_CHILD_SUPPORT, label: PTD_TYPES_LABEL.child_support },
  { value: PTD_TYPE_MISC, label: 'Voluntary Deduction' }, // once the miscellaneous garnishment rollout is removed, this can be moved to PTD_TYPES_LABEL
  {
    value: PTD_TYPE_MISC_GARNISHMENT,
    label: PTD_TYPES_LABEL.miscellaneous_garnishment,
  },
];

export const NAME_FIELD_CHAR_LIMIT = 40;
export const INITIAL_VALUES = {
  amount_type: 'amount',
  contribution_type: 'maximum_amount',
  type: '',
  name: '',
  start_date: null,
  end_date: null,
  amount: '',
  maximum_percent: '',
  priority: '',
  maximum_amount: '',
  annual_limit: '',
};
export const MISC_TYPE = 'miscellaneous';
